import { render, staticRenderFns } from "./ReviewStars.vue?vue&type=template&id=de3cd382"
import script from "./ReviewStars.vue?vue&type=script&lang=js"
export * from "./ReviewStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports